module.exports = __webpack_public_path__ + "static/media/bash.0d905be7.svg";